import React from "react";
import { connect, ConnectedProps } from 'react-redux';
import { Header, Icon } from "semantic-ui-react";
import * as Core from '../../core';
import userManager from '../userManager';

const connector = connect(
    null, 
    Core.actions
)
type PropsFromRedux = ConnectedProps<typeof connector>

export type SignoutCallbackProps = PropsFromRedux

class SignoutCallback extends React.Component<SignoutCallbackProps> {

    componentDidMount() {
        userManager.signoutRedirectCallback()
            .then(() => userManager.removeUser())
            .then(() => this.props.logoutSuccess())
            .catch(() => console.log("ERRORE"));
    }

    render() {
        return (
            <Header icon={true} textAlign="center">
                <Icon name="sign-out" circular />
                Stiamo completando la procedura di logout...
            </Header>
        );
    }
}
  
export default connector(SignoutCallback);
